module.exports = __webpack_public_path__ + "static/media/logo.8e0a33ec.png";